import * as React from 'react';
import type { BooleanFilterItem, FilterItem } from '../../../../types/Filter';
import Dropdown from '../../Dropdown/Dropdown';
import { AddFilterDropdown } from '../AddFilter/AddFilter';
import type { OnFilterChangeHandler } from '../types';
import DeleteFilterButton from './DeleteFilterButton';
import Styles from './filter-views.module.scss';

type Props = {
    filterItem: BooleanFilterItem;
    availableFilters: FilterItem[];
    onChange: OnFilterChangeHandler;
};

const DROPDOWN_ITEMS = [
    { name: 'Yes', value: 'true' },
    { name: 'No', value: 'false' },
    { name: 'Empty', value: 'undefined' }
];

const BooleanFilterView = (props: Props) => {
    const { filterItem } = props;
    const value = filterItem.value?.toString() ?? 'undefined';
    const selectedOperatorItem = DROPDOWN_ITEMS.find((item) => item.value === `${filterItem.value}`);

    return (
        <div className={Styles['filter-view']}>
            <AddFilterDropdown
                availableFilters={props.availableFilters}
                value={filterItem}
                onAdd={(filterItem) => filterItem !== props.filterItem && props.onChange(filterItem)}
            />
            <Dropdown
                options={DROPDOWN_ITEMS}
                value={value}
                className={Styles.control}
                menuClassName={Styles['filter-view-dropdown-tooltip']}
                onChange={(newValue) => {
                    let value: boolean | undefined = undefined;
                    if (newValue !== 'undefined') {
                        value = newValue === 'true';
                    }
                    if (value !== filterItem.value) {
                        props.onChange({
                            ...filterItem,
                            value
                        });
                    }
                }}
                dataTip={selectedOperatorItem?.name}
                dataTipOverflow
            />
            <div /> {/* just empty DIV for grid layout */}
            <DeleteFilterButton {...props} />
        </div>
    );
};

export default BooleanFilterView;
